(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueStatusDetailController', QueueStatusDetailController);

    QueueStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'QueueStatus'];

    function QueueStatusDetailController($scope, $rootScope, $stateParams, previousState, entity, QueueStatus) {
        var vm = this;

        vm.queueStatus = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:queueStatusUpdate', function(event, result) {
            vm.queueStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
